// Northwestern's undergraduate majors (#2743). Read on 2026-10-01 from the
// official 2025-2026 Undergraduate Catalog (catalogs.northwestern.edu), the
// edition posted on that date: each school's catalog page and its program
// list. Every bachelor's major kept; adjunct majors (MMSS, International
// Studies and the others, which can only be taken with another major),
// "second major for ISP students" tracks, accelerated BA/MA and BA/MS
// programs, minors, certificates and scholars programs left out. Degrees
// are the catalog's own: Weinberg grants the BA; McCormick the B.S. in each
// discipline and the BSE for Artificial Intelligence; Medill the BSJ;
// Bienen the BMus, plus the BAMus and BSMus with a major in music. The
// School of Communication (BACMN or BSCMN) and SESP (bachelor of science in
// education and social policy) do not tie a degree to each major, so those
// rows carry no degree and the group says why. The Integrated Science flag
// quotes the admissions testing FAQ (the college file's `tests` source). The
// KB's majors list was the starting point; the catalog wins.
const majors = 
{
    "slug": "northwestern-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Northwestern's official 2025-2026 Undergraduate Catalog, grouped by the school that offers it, with the degree it leads to. Adjunct majors (taken only alongside another major), second majors, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Weinberg College of Arts and Sciences",
            "source": {
                "label": "Northwestern 2025-2026 Undergraduate Catalog, Weinberg College of Arts and Sciences",
                "url": "https://catalogs.northwestern.edu/undergraduate/arts-sciences/"
            },
            "majors": [
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Art Theory and Practice",
                    "degree": "BA"
                },
                {
                    "name": "Asian American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Asian Languages and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Black Studies",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BA"
                },
                {
                    "name": "Earth and Planetary Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Gender and Sexuality Studies",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Integrated Science",
                    "degree": "BA",
                    "flag": "A selective program with its own application and admission process beyond general admission.",
                    "flagSource": "tests"
                },
                {
                    "name": "Italian Literature and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latina and Latino Studies",
                    "degree": "BA"
                },
                {
                    "name": "Legal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Middle East and North African Studies",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Slavic Languages and Literatures",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Communication",
            "source": {
                "label": "Northwestern 2025-2026 Undergraduate Catalog, School of Communication",
                "url": "https://catalogs.northwestern.edu/undergraduate/communication/"
            },
            "note": "Each major leads to a Bachelor of Arts in Communication (BACMN) or a Bachelor of Science in Communication (BSCMN).",
            "majors": [
                {
                    "name": "Communication Studies",
                    "degree": null
                },
                {
                    "name": "Dance",
                    "degree": null
                },
                {
                    "name": "Human Communication Sciences",
                    "degree": null
                },
                {
                    "name": "Performance Studies",
                    "degree": null
                },
                {
                    "name": "Radio/Television/Film",
                    "degree": null
                },
                {
                    "name": "Theatre",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of Education and Social Policy",
            "source": {
                "label": "Northwestern 2025-2026 Undergraduate Catalog, School of Education and Social Policy",
                "url": "https://catalogs.northwestern.edu/undergraduate/education-social-policy/"
            },
            "note": "Each major leads to the bachelor of science in education and social policy.",
            "majors": [
                {
                    "name": "Elementary Teaching",
                    "degree": null
                },
                {
                    "name": "Human Development in Context",
                    "degree": null
                },
                {
                    "name": "Learning Sciences",
                    "degree": null
                },
                {
                    "name": "Learning and Organizational Change",
                    "degree": null
                },
                {
                    "name": "Social Policy",
                    "degree": null
                }
            ]
        },
        {
            "name": "McCormick School of Engineering and Applied Science",
            "source": {
                "label": "Northwestern 2025-2026 Undergraduate Catalog, McCormick School of Engineering and Applied Science",
                "url": "https://catalogs.northwestern.edu/undergraduate/engineering-applied-science/"
            },
            "majors": [
                {
                    "name": "Applied Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "BSE"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Manufacturing and Design Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Medill School of Journalism, Media, Integrated Marketing Communications",
            "source": {
                "label": "Northwestern 2025-2026 Undergraduate Catalog, Medill School of Journalism, Media, Integrated Marketing Communications",
                "url": "https://catalogs.northwestern.edu/undergraduate/journalism-media-integrated-marketing-communications/"
            },
            "majors": [
                {
                    "name": "Journalism",
                    "degree": "BSJ"
                }
            ]
        },
        {
            "name": "Bienen School of Music",
            "source": {
                "label": "Northwestern 2025-2026 Undergraduate Catalog, Bienen School of Music",
                "url": "https://catalogs.northwestern.edu/undergraduate/music/"
            },
            "majors": [
                {
                    "name": "Composition",
                    "degree": "BMus"
                },
                {
                    "name": "Jazz Studies",
                    "degree": "BMus"
                },
                {
                    "name": "Music",
                    "degree": "BAMus"
                },
                {
                    "name": "Music",
                    "degree": "BSMus"
                },
                {
                    "name": "Music Cognition",
                    "degree": "BMus"
                },
                {
                    "name": "Music Education",
                    "degree": "BMus"
                },
                {
                    "name": "Music Theory",
                    "degree": "BMus"
                },
                {
                    "name": "Musicology",
                    "degree": "BMus"
                },
                {
                    "name": "Piano",
                    "degree": "BMus"
                },
                {
                    "name": "String Instruments",
                    "degree": "BMus"
                },
                {
                    "name": "Voice and Opera",
                    "degree": "BMus"
                },
                {
                    "name": "Winds and Percussion Instruments",
                    "degree": "BMus"
                }
            ]
        }
    ]
};

export default majors;
